/* tslint:disable */
/* eslint-disable */
/**
 * Hermes Console
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    DriverPaymentsSummaryRow,
    DriverPaymentsSummaryRowFromJSON,
    DriverPaymentsSummaryRowFromJSONTyped,
    DriverPaymentsSummaryRowToJSON,
} from './';

/**
 * 乗務員別請求サマリ
 * @export
 * @interface DriverPaymentsSummaryList
 */
export interface DriverPaymentsSummaryList {
    /**
     * 
     * @type {Array<DriverPaymentsSummaryRow>}
     * @memberof DriverPaymentsSummaryList
     */
    payments?: Array<DriverPaymentsSummaryRow>;
    /**
     * 合計回数
     * @type {number}
     * @memberof DriverPaymentsSummaryList
     */
    sumTrips?: number;
    /**
     * 請求金額
     * @type {number}
     * @memberof DriverPaymentsSummaryList
     */
    sumPrice?: number;
}

export function DriverPaymentsSummaryListFromJSON(json: any): DriverPaymentsSummaryList {
    return DriverPaymentsSummaryListFromJSONTyped(json, false);
}

export function DriverPaymentsSummaryListFromJSONTyped(json: any, ignoreDiscriminator: boolean): DriverPaymentsSummaryList {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'payments': !exists(json, 'payments') ? undefined : ((json['payments'] as Array<any>).map(DriverPaymentsSummaryRowFromJSON)),
        'sumTrips': !exists(json, 'sum_trips') ? undefined : json['sum_trips'],
        'sumPrice': !exists(json, 'sum_price') ? undefined : json['sum_price'],
    };
}

export function DriverPaymentsSummaryListToJSON(value?: DriverPaymentsSummaryList | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'payments': value.payments === undefined ? undefined : ((value.payments as Array<any>).map(DriverPaymentsSummaryRowToJSON)),
        'sum_trips': value.sumTrips,
        'sum_price': value.sumPrice,
    };
}


